const demographicData = {
  title: "Please answer these questions to know more about you.",
  name: "Name",
  birth: "Date of Birth",
  gender: "Gender",
  weight: "Weight"
};

export default demographicData;